var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrustRadius(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 105.631,
    height: 48.069,
    viewBox: "0 0 105.631 48.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.425,
    y1: 3.954,
    x2: 9.488,
    y2: 3.954,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de5a41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#116bf2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e50e5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_157148",
    "data-name": "Group 157148",
    transform: "translate(-815.959 -924.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2892",
    "data-name": "Path 2892",
    d: "M69.2,271.3a1.038,1.038,0,0,1,.276.176l4.348,4.348a.913.913,0,0,1,.276.653v20.055a.29.29,0,0,1-.3.3.285.285,0,0,1-.2-.075l-4.1-4.1a.913.913,0,0,1-.276-.653V271.3Z",
    transform: "translate(788.794 652.788)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2893",
    "data-name": "Path 2893",
    d: "M103.1,271.5a1.117,1.117,0,0,1,.276-.2v20.708a.913.913,0,0,1-.276.653l-4.1,4.1a.289.289,0,0,1-.427,0,.285.285,0,0,1-.075-.2V276.5a.857.857,0,0,1,.276-.628h0L103.1,271.5Z",
    transform: "translate(766.858 652.788)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2894",
    "data-name": "Path 2894",
    d: "M125.44,321.874l-.3-.3V317.3h-4.147a.307.307,0,0,0-.226.1h0l-2.966,2.966,9.5,9.525h0a.89.89,0,0,0,.653.251h5a.29.29,0,0,0,.3-.3.285.285,0,0,0-.075-.2Z",
    transform: "translate(752.408 618.348)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2895",
    "data-name": "Path 2895",
    d: "M103.877,271a.912.912,0,0,0-.653.276h0l-4.348,4.348h0a1.525,1.525,0,0,0-.176.251h12.139v11.008l.3.3,4.323-4.3a.913.913,0,0,0,.276-.653v-5.956a.912.912,0,0,0-.276-.653l-4.348-4.348a.912.912,0,0,0-.653-.276Z",
    transform: "translate(766.708 653.012)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2897",
    "data-name": "Path 2897",
    d: "M103.074,271.276a.912.912,0,0,1,.653-.276h6.584a.913.913,0,0,1,.653.276l4.348,4.348a.913.913,0,0,1,.276.653v.226a.612.612,0,0,0-.6-.6H99.1a.612.612,0,0,0-.6.6v-.226a.913.913,0,0,1,.276-.653Z",
    transform: "translate(766.858 653.012)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2898",
    "data-name": "Path 2898",
    d: "M139.847,314.8a.612.612,0,0,1-.6.6h-8.193a.162.162,0,0,0-.151.151.131.131,0,0,0,.05.1l4.323,4.323,4.323-4.3a.913.913,0,0,0,.276-.653V314.8Z",
    transform: "translate(742.601 620.22)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_157146",
    "data-name": "Group 157146",
    transform: "translate(815.959 924.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2896",
    "data-name": "Path 2896",
    d: "M33.365,271.276a.912.912,0,0,0-.653-.276H21.3a.29.29,0,0,0-.3.3.307.307,0,0,0,.1.226l4.1,4.1a.913.913,0,0,0,.653.276H37.411a.612.612,0,0,1,.6.6v-.226a.913.913,0,0,0-.276-.653Z",
    transform: "translate(8.922 -271)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_157143",
    "data-name": "Group 157143",
    transform: "translate(0 31.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2899",
    "data-name": "Path 2899",
    d: "M337.033,296.814c0-2.037-1.167-2.807-4.024-3.527-1.714-.422-2.161-.77-2.161-1.366s.547-.993,1.664-.993a7.978,7.978,0,0,1,3.527.969l.348-2.186a9.811,9.811,0,0,0-3.875-.77c-2.583,0-4.1,1.316-4.1,3.154,0,1.987,1.118,2.732,3.8,3.4,1.863.447,2.384.745,2.384,1.54,0,.72-.72,1.167-1.987,1.167a8.1,8.1,0,0,1-4.1-1.267l-.348,2.21a10.065,10.065,0,0,0,4.322,1.043C335.469,300.192,337.033,298.926,337.033,296.814Zm-10.158,3.154V289.09h-2.633v7.376a4.109,4.109,0,0,1-2.707,1.391c-1.068,0-1.515-.646-1.515-1.614v-7.178h-2.633v7.848a2.938,2.938,0,0,0,3.254,3.229,5.648,5.648,0,0,0,3.775-1.739l.373,1.515Zm-11.077,0V289.09H313.19v10.878Zm-1.292-15.647a1.515,1.515,0,1,1-1.515,1.515A1.505,1.505,0,0,1,314.506,284.322Zm-5.489,12.021a3.472,3.472,0,0,1-2.682,1.54c-1.316,0-2.285-1.018-2.285-3.154,0-2.384,1.142-3.552,2.682-3.552a5.1,5.1,0,0,1,2.285.472Zm2.608,3.626V283.8l-2.608.447v5.24a8.626,8.626,0,0,0-2.658-.422c-2.633,0-4.967,1.788-4.967,5.812,0,3.626,1.912,5.315,4.3,5.315a4.56,4.56,0,0,0,3.5-1.714l.224,1.49Zm-13.933-2.98a4.2,4.2,0,0,1-2.782,1.217c-.894,0-1.465-.5-1.465-1.267,0-1.043.82-1.962,4.272-2.36v2.409Zm2.608,2.98v-7.4c0-2.558-1.391-3.6-4.272-3.6a11.686,11.686,0,0,0-4.421.869l.323,2.086a10.479,10.479,0,0,1,3.8-.869c1.242,0,1.987.447,1.987,1.614v.348c-4.62.447-6.855,1.565-6.855,4.173a2.9,2.9,0,0,0,3.229,2.98,5.318,5.318,0,0,0,3.8-1.614l.248,1.391H300.3Zm-9.885-.4-4.173-5.688a4.04,4.04,0,0,0,3.13-4.048c0-2.782-2.012-4.371-5.34-4.371h-4.595v14.5h2.707v-5.613h1.316l4.073,5.737Zm-3.75-9.587c0,1.515-1.142,2.335-2.98,2.335h-1.54V287.7h1.689C285.7,287.724,286.664,288.544,286.664,289.984Zm-8.594,9.984-.323-2.161a5.818,5.818,0,0,1-.944.074c-1.068,0-1.49-.472-1.49-1.366V291.2h2.757l-.447-2.111h-2.31v-3.775l-2.583.447v3.328h-1.763V291.2h1.763v5.737c0,2.434,1.441,3.179,3.6,3.179A6.766,6.766,0,0,0,278.071,299.969Zm-7.65-3.154c0-2.037-1.167-2.807-4.024-3.527-1.714-.422-2.161-.77-2.161-1.366s.546-.993,1.664-.993a7.978,7.978,0,0,1,3.527.969l.373-2.186a9.81,9.81,0,0,0-3.875-.77c-2.583,0-4.1,1.316-4.1,3.154,0,1.987,1.118,2.732,3.8,3.4,1.863.447,2.384.745,2.384,1.54,0,.72-.72,1.167-1.987,1.167a7.857,7.857,0,0,1-4.048-1.267l-.373,2.21a10.087,10.087,0,0,0,4.346,1.043C268.856,300.192,270.421,298.926,270.421,296.814Zm-10.009,3.154V289.09h-2.633v7.376a4.109,4.109,0,0,1-2.707,1.391c-1.068,0-1.515-.646-1.515-1.614v-7.178h-2.633v7.848a2.938,2.938,0,0,0,3.254,3.229,5.648,5.648,0,0,0,3.775-1.739l.373,1.515ZM249.682,291.5l-.6-2.558a4.785,4.785,0,0,0-3.427,2.409l-.5-2.26H243.2v10.878h2.558V293.76A5.1,5.1,0,0,1,249.682,291.5Z",
    transform: "translate(-231.403 -283.8)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2900",
    "data-name": "Path 2900",
    d: "M209.137,292.909l-.6-2.409H195.7v2.409h4.843V305h2.707v-12.1Z",
    transform: "translate(-195.7 -288.836)",
    fill: "url(#linear-gradient)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrustRadius);
export default __webpack_public_path__ + "static/media/icon-trust-radius.57b408f33a3fd99f92fa6e1cc918e8ab.svg";
export { ForwardRef as ReactComponent };